import styled, { DefaultTheme } from "styled-components";
import colors from "./colors.tsx";

// Interface pour définir les propriétés du thème
export interface Theme extends DefaultTheme {
  theme: string,
}

// Interface pour définir les propriétés de la transition
export interface ThemeTransition extends Theme {
  orientation: string;
}

// Composant Transition avec les propriétés du thème et d'orientation
export const Transition = styled.div<ThemeTransition>`
  background: ${props => (
  props.theme === 'blanc'
    ? `linear-gradient(${props.orientation}, ${colors.light_pink} 0%, ${colors.white} 100%);`
    : `linear-gradient(${props.orientation}, ${colors.white} 0%, ${colors.light_pink} 100%);`
)};
  width: 100%;
  height: 5rem;
  pointer-events: none;
`;
